import { useEffect, useMemo, useState } from "react";
import ChoiceField from "../../../fields/ChoiceField";

const DEFAULT_CHANNELS = Object.freeze([
  { value: 25, label: "25" },
  { value: 20, label: "20" },
  { value: 15, label: "15" },
  { value: 11, label: "11" },
  { value: 14, label: "14" },
]);

const DEFAULT_RECOMMENDATION_ORDER = [25, 20, 15, 11, 14];

const ZigbeeChannelChoiceField = (props) => {
  const [recommendedValue, setRecommendedValue] = useState(null);

  useEffect(() => {
    // recompute whenever inputs change
    const hubChan = props.hub?.zigbeeChannel;
    if (hubChan) {
      setRecommendedValue(hubChan);
      return;
    }

    const setupChannels = (props.allHubs || [])
      .map((h) => h.zigbeeChannel)
      .filter(Boolean);

    const firstFree =
      DEFAULT_RECOMMENDATION_ORDER.find((v) => !setupChannels.includes(v)) ??
      DEFAULT_RECOMMENDATION_ORDER[0];

    setRecommendedValue(firstFree);
  }, [props.hub?.zigbeeChannel, props.allHubs]);

  // derive items without mutating the defaults
  const items = useMemo(() => {
    return DEFAULT_CHANNELS.map((c) => {
      const base = c.label.replace(/ \(Recommended\)$/, ""); // defensive
      return {
        value: c.value,
        label: c.value === recommendedValue ? `${base} (Recommended)` : base,
      };
    });
  }, [recommendedValue]);

  return (
    <ChoiceField
      selectedItem={items.find((i) => i.value === props.selectedChannel) || items.find((i) => i.label.includes('Recommended')) || null}
      items={items}
      setValue={props.setValue}
      cellControl={props.cellControl}
      excludeNone={props.excludeNone}
      disabled={props.disabled}
    />
  );
};

export default ZigbeeChannelChoiceField;
